import { RadioGroup, RadioGroupProps } from '@arcadiapower/shrike';
import styled from 'styled-components';

export const StyledRadioGroup = styled(RadioGroup)<RadioGroupProps>`
  label {
    padding: 8px;
    margin: 0 16px 0 0;
  }
`;
